import ACTIONS from '../../actions';
import { loadFromStorage, saveToStorage } from '../util';
var initialState = {
  userName: loadFromStorage('ECR.EOS.UserName', null),
  environmentName: null,
  timezone: loadFromStorage('environment.settings.timezone', null),
  //rehydrate
  permissions: []
};
export var userInfoReducer = function userInfoReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case ACTIONS.USER_INFO_GET_RESOLVED:
      {
        if (action.payload.timezone) saveToStorage('environment.settings.timezone', action.payload.timezone);
        return action.payload;
      }

    default:
      return state;
  }
};
export default userInfoReducer;